import type { Appointment } from '../appointments/appointment'
import type { ScheduleSlotTime } from './schedule-slots'
import type { ScheduleGroupEntity } from '../schedule-groups/schedule-group.entity'

export class Schedule {
    scheduleId: string
    label: string
    status: number
    startMinute: number
    endMinute: number
    position: number
    range: number
    companyId: string
    createdAt: Date
    updatedAt: Date
    appointments: Appointment[]
    selectedDate?: Date
    slots: ScheduleSlotTime[]
    public: boolean
    onlineFitsAllowed?: number
    picture: string
    users?: string[]
    attendants?: string[]
    onlineAtendant?: string
    lastAppointmentChange?: Date
    scheduleGroupId?: string
    group?: ScheduleGroupEntity
    widthFactor?: number // largura relativa da coluna na tela da agenda (só computador): 1 = padrão, 2 = dobro
}
